export type NotificationKeys = 'SUCCESS' | 'ERROR' | 'NEUTRAL';
export type NotificationTypes = 'success' | 'error' | 'none';

export interface Notifications {
  message: React.ReactNode;
  type: NotificationTypes;
}

export type Notification = Record<NotificationKeys, Notifications>;

export const notificationMessage = (message: React.ReactNode): Notification => ({
  SUCCESS: {
    message,
    type: 'success',
  },
  ERROR: {
    message,
    type: 'error',
  },
  NEUTRAL: {
    message,
    type: 'none',
  },
});
